import React from 'react'
import TDS from "./components/Index"

const Index = () => {
  return (
    <div className='tds-container'><TDS /></div>
  )
}

export default Index